// extracted by css-extract-rspack-plugin
export default {"title":"title-SewPk8","description":"description-ZPd56E","body":"body-uw9xz_","titleRow":"titleRow-S_EKJe"};